import { Box, BoxProps } from "@chakra-ui/react";

export function RightArrowIcon({ ...props }: BoxProps) {
  return (
    <Box {...props}>
      <svg
        width="21"
        height="21"
        viewBox="0 0 21 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M3.2085 10.4998C3.2085 10.1546 3.48832 9.87482 3.8335 9.87482L16.3335 9.87482C16.6787 9.87482 16.9585 10.1546 16.9585 10.4998C16.9585 10.845 16.6787 11.1248 16.3335 11.1248L3.8335 11.1248C3.48832 11.1248 3.2085 10.845 3.2085 10.4998Z"
          fill="currentColor"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12.5581 5.89131C12.8021 5.64723 13.1979 5.64723 13.4419 5.89131L17.0194 9.46872C17.0261 9.47545 17.0329 9.48222 17.0397 9.48901C17.1606 9.60983 17.2913 9.74047 17.3868 9.86562C17.4987 10.0122 17.6191 10.222 17.6191 10.4999C17.6191 10.7778 17.4987 10.9876 17.3868 11.1342C17.2913 11.2594 17.1606 11.39 17.0397 11.5108C17.0329 11.5176 17.0261 11.5244 17.0194 11.5311L13.4419 15.1085C13.1979 15.3526 12.8021 15.3526 12.5581 15.1085C12.314 14.8644 12.314 14.4687 12.5581 14.2246L16.1355 10.6472C16.1939 10.5889 16.2412 10.5415 16.2814 10.4999C16.2412 10.4583 16.1939 10.411 16.1355 10.3526L12.5581 6.77519C12.314 6.53112 12.314 6.13539 12.5581 5.89131Z"
          fill="currentColor"
        />
      </svg>
    </Box>
  );
}
